module.exports = __webpack_public_path__ + "static/media/iceland-boat.be1e6983.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/small/iceland-boat.png
 ** module id = 195
 ** module chunks = 0
 **/